import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import React from 'react';
import * as styles from './Section.module.scss';

const cx = classNames.bind(styles);

const Section = ({
  children,
  theme,
  waveTop,
  waveBottom,
  padding,
  className,
  style,
  id,
  Tag,
  center,
  ...other
}) => (
  <Tag
    className={cx(className, {
      [`theme${theme}`]: theme,
      themeWave: (waveTop || waveBottom),
      center,
    })}
    style={style}
    id={id}
    {...other}
  >
    {waveTop && (
      <svg
        className={styles.waveTop}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1431 55"
      >
        <path d="M984.5,47.07c-216-1-259-32-536-44C202.3-7.59,34.32,12.55,0,17.16V55.07H1431V10.93C1394.4,16.57,1181.16,48,984.5,47.07Z" />
      </svg>
    )}
    <div
      className={cx(styles.inner, {
        [`padding${padding}`]: padding,
      })}
    >
      {children}
    </div>
    {waveBottom && (
      <svg
        className={styles.waveBottom}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1431 57"
      >
        <path d="M0,0V10.26c17,.8,73.29,3.27,165.5,5.74,112,3,422,36,686,41,245.24,4.64,539.84-13.21,579.5-15.71V0Z" />
      </svg>
    )}
  </Tag>
);
Section.propTypes = {
  children: PropTypes.node.isRequired,
  theme: PropTypes.oneOf(['Blue', 'GreyBlue', 'Grey', 'Indigo', 'Dark']),
  waveTop: PropTypes.bool,
  waveBottom: PropTypes.bool,
  padding: PropTypes.oneOf([
    'Xl',
    'L',
    'M',
    'S',
    'None',
    'TopXl',
    'TopL',
    'TopM',
    'TopS',
    'BottomS',
    'BottomM',
    'BottomL',
    'BottomXl'
  ]),
  className: PropTypes.string,
  style: PropTypes.object,
  id: PropTypes.string,
  Tag: PropTypes.oneOf(['div', 'section']),
  center: PropTypes.bool,
};
Section.defaultProps = {
  waveTop: false,
  waveBottom: false,
  padding: 'L',
  Tag: 'section',
  center: false,
};

export default Section;
